import { defineAction } from '~/prix'
import alertMockAction from './alertMock.action.json' with { type: 'json' }
import { z } from 'zod'

const alertMockDefinition = defineAction({
  ...alertMockAction,

  input: z.object({
    count: z.number().default(50),
    seed: z.number().default(10),
  }),
  output: z.object({}),
})

export default alertMockDefinition
